
import { useSyncExternalStore } from "react";

const KEYBOARD_MIN_HEIGHT = 120;
const EDITABLE_SELECTOR =
  'textarea, input:not([type="checkbox"], [type="radio"], [type="button"], [type="submit"], [type="reset"], [type="range"], [type="color"], [type="file"], [type="hidden"])';

function subscribe(onChange: () => void) {
  const viewport = window.visualViewport;
  viewport?.addEventListener("resize", onChange);
  window.addEventListener("focusin", onChange);
  window.addEventListener("focusout", onChange);
  return () => {
    viewport?.removeEventListener("resize", onChange);
    window.removeEventListener("focusin", onChange);
    window.removeEventListener("focusout", onChange);
  };
}

function snapshot(): boolean {
  const viewport = window.visualViewport;
  if (!viewport) return false;
  const active = document.activeElement;
  const editable = active instanceof HTMLElement && (active.isContentEditable || active.matches(EDITABLE_SELECTOR));
  return editable && window.innerHeight - viewport.height > KEYBOARD_MIN_HEIGHT;
}

const serverSnapshot = () => false;

export function useKeyboardOpen(): boolean {
  return useSyncExternalStore(subscribe, snapshot, serverSnapshot);
}
